import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

import logoMark from "../../assets/images/monitorwise-mark-dark.svg";

const Sidebar = (props: any) => {

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoMark} alt="Monitorwise" height="22" />
            </span>
            <span className="logo-lg">
              <span style={{display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '18px 0'}}>
                <img src={logoMark} alt="" height="24" />
                <h4 style={{margin: 0, color: 'white', fontWeight: 700}}>MonitorWise</h4>
              </span>
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoMark} alt="Monitorwise" height="22" />
            </span>
            <span className="logo-lg">
              <span style={{display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '18px 0'}}>
                <img src={logoMark} alt="" height="24" />
                <h4 style={{margin: 0, color: 'white', fontWeight: 700}}>MonitorWise</h4>
              </span>
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state: any) => {
  return {
    layout: state.Layout,
  }
}

const SideBar: any = connect<any, any>(
  mapStatetoProps,
  {}
)(withRouter<any, any>(withTranslation<any>()(Sidebar)))

export default SideBar;
